import texts from './post.texts'

class PostController {
    constructor($scope, $state, $stateParams, SharedMoments, Category, Color) {
        this.name = 'post'

        this.$scope = $scope
        this.$state = $state
        this.$stateParams = $stateParams

        this.SharedMoments = SharedMoments
        this.Category = Category
        this.Color = Color
    }

    $onInit() {
        this.postId = this.$stateParams.id

        this.posts = this.SharedMoments.getLoadedPosts()
        this.selectedCategories = this.Category.getSelectedCategories()
        this.search = this.$stateParams.search

        this.render()

        this.bindEvents()

        this.setActivePost()

        this.watchLanguage()

        this.watchPosts()
    }

    render() {
        this.language = localStorage.getItem('tourists_lang') || 'EN'

        const {
            CLOSE
        } = texts[this.language]

        this.CLOSE = CLOSE
    }

    bindEvents() {
        $('#post').focus()
    }

    setActivePost() {
        this.activePost = this.posts.find((item, index) => {
            if (item.id === this.postId) {
                this.activeIndex = index

                return item
            }
        })

        if (this.activePost) {
            this.photoStyle = {
                'background-image': `url("${this.activePost.photoUrl}")`
            }

            this.colors = this.Color.getColors(this.activePost.cardType, this.activePost.cardGroup)
        } else {
            this.getPost()
        }
    }

    loadPosts() {
        if (this.isLoading || (this.postsCount && this.postsCount === this.posts.length)) {
            this.isLoading = false

            return
        }

        this.isLoading = true

        if (this.search) {
            this.searchPosts()
        } else {
            this.getPosts()
        }
    }

    getPost() {
        if (this.isLoading) {
            return
        }

        this.isLoading = true

        this.SharedMoments.getPost(this.$stateParams.id)
            .then(({
                data
            }) => {
                this.SharedMoments.unshiftPost(data)

                this.isLoading = false
            })
            .catch((err) => {
                console.log('Error occured in method getPost', err)

                this.error = err.data
            })
    }

    getPosts() {
        this.SharedMoments.getPosts(this.selectedCategories, this.urls)
            .then(({
                data
            }) => {
                const {
                    count,
                    posts
                } = data

                this.postsCount = count

                this.SharedMoments.addPosts(posts)
                this.isLoading = false

                this.activeIndex += 1

                const activePost = this.posts[this.activeIndex]

                if (activePost && activePost.id !== this.search) {
                    this.$state.go('home.post', {
                        id: activePost.id
                    }, {
                        notify: false
                    })
                }
            })
            .catch((err) => {
                console.log('Error occured in method getPosts', err)

                this.error = err.data
            })
    }

    searchPosts() {
        this.SharedMoments.searchPosts(this.search, this.urls, this.$stateParams.id)
            .then(({
                data
            }) => {
                const {
                    count,
                    posts
                } = data

                this.postsCount = count

                this.SharedMoments.addPosts(posts)
                this.isLoading = false

                this.activeIndex += 1

                const activePost = this.posts[this.activeIndex]

                if (activePost && activePost.id !== this.search) {
                    this.$state.go('home.post', {
                        id: activePost.id
                    }, {
                        notify: false
                    })
                }
            })
            .catch((err) => {
                console.log('Error occured in method searchPosts', err)

                this.error = err.data
            })
    }

    prevPost() {
        if (this.activeIndex === 0) {
            return
        }

        this.activeIndex -= 1

        this.activePost = this.posts[this.activeIndex]

        this.$state.go('home.post', {
            id: this.activePost.id
        }, {
            notify: false
        })
    }

    nextPost() {
        if (this.activeIndex < this.posts.length - 1) {
            this.activeIndex++
        }

        if (this.activeIndex < this.posts.length) {
            this.activePost = this.posts[this.activeIndex]

            this.$state.go('home.post', {
                id: this.activePost.id
            }, {
                notify: false
            })
        }

        if (this.activeIndex >= this.posts.length - 1) {
            this.loadPosts()
        }
    }

    onClick(event) {
        if (event.target.id === 'post') {
            this.$state.go('home')
        }
    }

    onKeyUp(event) {
        if (event.key === 'Escape') {
            this.$state.go('home')
            return
        }

        if (event.key === 'ArrowLeft') {
            this.prevPost()
        } else if (event.key === 'ArrowRight') {
            this.nextPost()
        }
    }

    watchPosts() {
        this.$scope.$watch(() => this.SharedMoments.getLoadedPosts(), (newValue) => {
            if (newValue) {
                this.posts = newValue
                this.urls = newValue.map(item => item.url)

                this.setActivePost()
            }
        })
    }

    watchLanguage() {
        this.$scope.$watch(() => localStorage.getItem('tourists_lang'), (newValue, oldValue) => {
            if (newValue && newValue !== oldValue) {
                this.render()
            }
        })
    }
}

PostController.$inject = ['$scope', '$state', '$stateParams', 'SharedMoments', 'Category', 'Color']

export default PostController



// WEBPACK FOOTER //
// ./client/app/components/home/post/post.controller.js